module.exports = __webpack_public_path__ + "media/src/images/brand_item-a607547bc66908bdb9b7f71f89547c52.svg";